import { z } from 'zod/v4';

export const mapRegionSchema = z.object({
  mapsetId: z.number(),
  mapsetName: z.string(),
});

export type MapRegion = z.infer<typeof mapRegionSchema>;
